import { filter } from "lodash";
import { getItemsFromCollection } from "directus/src/operations";

export async function fetchFixedJobConfig({ jobId }) {
  try {
    const query = {
      fields: ["id", "amount", "currency", "budget_margin"],
      filter: {
        job: {
          _eq: jobId,
        },
      },
    };

    const response = await getItemsFromCollection("fixed_job_config", query);
    const item = response[0];
    if (item) {
      if (typeof item.amount === "string") item.amount = Number(item.amount);
    }
    return item;
  } catch (error) {
    console.error("Error creating fixed config:", error);
    throw error;
  }
}
